import { DamPage } from "../pages/DamPage";

export interface ExternalLink {
    url: string;
    text: string;
}

export interface Page {
    id: string;
    position: [number, number, number];
    title: string;
    image: string;
    imageScale: number;
    tags?: string[];
    date: string;
    shortDescription?: string;
    description: string;
    links: ExternalLink[];
    borderColor?: string;
    mapScale?: number;
}

export const SPECIAL_PAGES: Record<string, React.FC<any>> = {
    // 'dam': DamPage,
    // 'asciicoditor': AsciiPage
};

export const pages: Page[] = [
    /////// CENTER //////
    // {
    //     id: "",
    //     position: [0.25, 0.0, 0.25],
    //     title: "",
    //     date: "02/2026",
    //     image: "",
    //     imageScale: 10.0,
    //     tags: ["Three.js", "React", "TypeScript"],
    //     shortDescription: "the one you're looking at",
    //     description: `Uses Three.js and React to render this very website! Places the user in a nice, stylized field, allowing them to view and learn about my projects.
    //                     <br/><br/>
    //                     <i><span style='color: rgb(255, 255, 255, 0.5);'>(pro tip: you can also use arrow keys to rotate the camera!)</span></i>`,
    //     links: [],
    //     // mapScale: 1.0,
    // },


    {
        id: "portfolio-site",
        position: [0.25, 0.0, 0.25],
        title: "This Website",
        date: "02/2026",
        image: "portfolio_site.png",
        imageScale: 2.0,
        tags: ["Three.js", "React", "TypeScript"],
        shortDescription: "the one you're looking at",
        description: `Uses Three.js and React to render this very website! Places the user in a nice, stylized field, allowing them to view and learn about my projects.
                        <br/><br/>
                        <i><span style='color: rgb(255, 255, 255, 0.5);'>(pro tip: you can also use arrow keys to rotate the camera!)</span></i>`,
        links: [],
        // mapScale: 1.0,
    },

    /////// SILLY SITES ///////
    {
        id: "ascii-grapher",
        position: [-4, 3.0, -6],
        title: "ASCII Grapher",
        date: "05/2023",
        image: "wave.png", // find a better photo
        imageScale: 2.0,
        tags: ["JavaScript", "HTML", "CSS"],
        shortDescription: "stylized graphing",
        description: `Graphs user-defined periodic functions with ASCII values. Refresh the page for a random function.
        <br/><br/>This was the second site I made, after just learning how to use JavaScript`,
        links: [
            {
                url: "https://github.com/ari-goldman/ascii-functions",
                text: "github",
            },
            {
                url: "https://ascii-functions.ari-goldman.xyz/", // change in future?
                text: "visit",
            },
        ],
    },
    {
        id: "splitting-shapes",
        position: [-2, 2.25, -6],
        title: "Splitting Shapes",
        date: "12/2022",
        image: "shapes.png",
        imageScale: 2.0,
        tags: ["JavaScript", "HTML", "CSS"],
        shortDescription: "a simple, zen website",
        description:
            "As my first foray into JavaScript, I decided to make a simple, zen website. Each rectangle clicked turns into two more, forever.",
        links: [
            {
                url: "https://github.com/ari-goldman/splitting-shapes",
                text: "github",
            },
            {
                url: "https://splitting-shapes.ari-goldman.xyz/",
                text: "visit",
            },
        ],
    },

    //////// GRAPHICS ///////
    {
        id: "island",
        position: [0.0, 0.5, -2.0],
        title: "Island Generator",
        date: "11/2025",
        image: "island.jpg",
        imageScale: 2.25,

        tags: ["C++", "OpenGL", "GLSL"],
        shortDescription: "GPU erosion simulation and renderer",
        description:
            "Island terrain generator with a GPU-accelerated hydraulic erosion simulation, and some nice raymarched clouds to accompany the terrain.",
        links: [
            {
                url: "https://youtu.be/pFPAKgLexl0?si=7TLqJ73vsei2pkEI",
                text: "demo",
            },
            {
                url: "https://github.com/ari-goldman/island-generator",
                text: "github",
            },
        ],
    },
    {
        id: "pbrt-cars",
        position: [0.0, 1.0, -4.0],
        title: "PBRT Render",
        date: "04/2025",
        image: "trackmania.png",
        imageScale: 2.0,
        tags: ["PBRTv4"],
        shortDescription: undefined,
        description: `Using <a href="https://pbrt.org/" target="_blank">physically based ray tracing</a>, renders a scene of three 
        <a href="https://www.trackmania.com/?lang=en" target="_blank">Trackmania</a> cars driving down a dark highway.`,
        links: [
            {
                url: "https://github.com/ari-goldman/trackmania-pbrt",
                text: "info & final renders",
            },
        ],
    },
    {
        id: "cell-visualizer",
        position: [0.0, 1.5, -6.0],
        title: "Cell Visualizer",
        date: "12/2023",
        image: "cell.png", // find a better photo
        imageScale: 2.0,
        tags: ["C", "OpenGL", "GLSL"],
        shortDescription: "3D cell processes in OpenGL",
        description: `Visualizes three different cell organelle functions in 3D - ribosomes, mitochondria, and the golgi apparatus.<br/><br/>
        I utilized various animated vertex and raymarching shaders to make these visualizations come to life.`,
        links: [
            {
                url: "https://github.com/ari-goldman/cell-visualizer",
                text: "github",
            },
        ],
    },

    //////// Games ////////
    {
        id: "roller-dining",
        position: [-2.0, 0.5, 0.0],
        title: "Roller Dining",
        date: "02/2026",
        image: "roller_dining.png",
        imageScale: 1.13,
        tags: ["Godot", "Game Jam", "3D"],
        shortDescription: "physics-based roller skating chaos",
        description: `Play as a roller-skating food courier delivering orders to hungry customers. The physics-driven skating mechanics let you build momentum, launch off ramps, and pull off tricks as you race to maximize customer satisfaction.
                        <br/><br/>
                        Made in ~9 days for the <a href="https://itch.io/jam/bigmode-game-jam-2026" target="_blank">Bigmode Game Jam 2026</a>. (results pending...)`,
        links: [
            {
                url: "https://sunseten.itch.io/roller-dining",
                text: "play",
            },
        ],
    },
    {
        id: "simpler-times",
        position: [-4.0, 1.0, 0.0],
        title: "The Simpler Times",
        date: "01/2026",
        image: "simpler_times.png",
        imageScale: 1.0,
        tags: ["Godot", "Game Jam", "2D"],
        shortDescription: "time-crunched work simulator",
        description: `A short game about writing the best, yet simple, headline you can with words found around the office.
                        <br/><br/>
                        Made in 72 hours for the <a href="https://itch.io/jam/brainless-mini-game-jam" target="_blank">Brainless Game Jam</a>, placing second in the creativity category!`,
        links: [
            {
                url: "https://youtu.be/aU5ACoL2Ke8?si=CO-qUt8Uj-8kax2_",
                text: "youtube video",
            },
            {
                url: "https://goobst.itch.io/the-simpler-times",
                text: "play",
            },
        ],
    },
    {
        id: "dam",
        position: [-2.0, 1.25, -2.0],
        title: "DAM!",
        date: "11/2025 - 12/2025",
        image: "dam_image.png",
        imageScale: 2.0,
        tags: ["Godot", "2D"],
        shortDescription: "time and resource management (+beavers)",
        description:
            `Play as a beaver working to protect its dam from the ever growing waters of the lake above! Manage time and resources efficiently while collecting upgrades to make it through the winter.
            <br/><br/>
            Made on a team of 4, where I was the main programmer.`,
        links: [
            {
                url: "https://github.com/Juniper19/beaver-game",
                text: "github",
            },
            {
                url: "https://goobst.itch.io/dam?secret=60YmJagdeKBMgewQFw1vOdYmofI",
                text: "play",
            },
        ],
        mapScale: 1.0,
    },
    {
        id: "asciicoditor",
        position: [-4.0, 1.75, -2.0],
        date: "08/2024",
        title: "// ASCIICODITOR",
        image: "asciicoditor.png",
        imageScale: 1.75,
        tags: ["Godot"],
        shortDescription: "an ASCII art creator",
        description:
            `A robust ASCII art creation tool with 200+ characters, 10 colors, and 4 post-processing effects.
            <br/><br/>
            <i>"The enemy of art is the absence of limitations"<br/>- Orson Welles</i>`,
        links: [
            {
                url: "https://github.com/ari-goldman/asciicoditor",
                text: "github",
            },
            {
                url: "https://goobst.itch.io/asciicoditor",
                text: "use",
            },
        ],
    },
    {
        id: "minecraft-bingo",
        position: [-6.0, 2.25, -2.0],
        title: "Minecraft Bingo",
        date: "06/2022",
        image: "bingo.png", // find a better photo
        imageScale: 3.0,
        tags: ["Java", "Networking"],
        shortDescription: "bingo, but in Minecraft",
        description: `A plugin for Java Minecraft 1.20.6 that adds a multiplayer bingo gamemode, 
                    where players have to obtain the items on the board to try to get the highest score by the end of the time limit!`,
        links: [
            {
                url: "https://github.com/OGPanda18/BingoPlugin",
                text: "github",
            },
        ],
    },
    {
        id: "survivors-game",
        position: [-6.0, 2.0, 0.0],
        title: "Survivors Game",
        date: "10/2025",
        image: "survivors.png", // find a better photo
        imageScale: 1.0,
        tags: ["Godot", "2D"],
        shortDescription: "quick time survival",
        description: `Survive as long as possible, defending against the hordes of incoming slimes. Gather XP and powerups to grow stronger and unlock more space to move around!
                        <br/><br/>This was made for my game development class, and mainly was used to give us a chance to explore Godot (though I already had a couple years' experience).`,
        links: [
            {
                url: "https://github.com/ari-goldman/atlas-godot-tutorial",
                text: "github",
            },
            {
                url: "https://goobst.itch.io/survivors-game",
                text: "play"
            }
        ],
    },

    /////// OTHER STUFF //////
    {
        id: "fpga-drums",
        position: [-2.0, 1.75, -4.0],
        title: "FPGA Drum Machine",
        date: "12/2025",
        image: "fpga_drum.png", // find a better photo
        imageScale: 1.7,
        tags: ["Verilog"],
        shortDescription: "drum synthesizer on an FPGA",
        description: `A full drum machine and sequencer on an FPGA with a variable-speed 16-beat loop. All sounds are completely synthesized, and can be used atop one another.
                        <br/><br/>
                        Since this was made as a freeform final project for school, the code is <i>not</i> posted online.`,
        links: [
            {
                url: "https://www.youtube.com/watch?v=S1fGA_4pF60",
                text: "demo",
            },
        ],
    },
    {
        id: "dfs",
        position: [-4, 2.5, -4],
        title: "Distributed File System",
        date: "04/2025",
        image: "files.png", // find a better photo
        imageScale: 1.25,
        tags: ["C", "Networking", "Linux"],
        shortDescription: "multi-server file system",
        description: `Presents the user with a unified file system, but stores files across different servers.
                        Files are broken into chunks, which are replicated across multiple servers, letting the 
                        system work even with 2 down network nodes.`,
        links: [
            {
                url: "https://github.com/ari-goldman/distributed-file-system",
                text: "github",
            },
        ],
    },
];
